// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"_2dhm_","inputSearch":"_2V4t4","searchIcon":"_1iPJS"};